"use client";

import { useEffect, useState } from "react";
import { MobileComparisonBadge } from "./mobile-comparison-badge";
import { DesktopComparisonBadge } from "./desktop-comparison-badge";

export function MinimizedComparisonBadge() {
	const [isMobile, setIsMobile] = useState(false);
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);

		// Check if mobile on mount
		const checkMobile = () => {
			setIsMobile(window.innerWidth < 768);
		};

		checkMobile();

		// Listen for resize events
		window.addEventListener("resize", checkMobile);
		return () => window.removeEventListener("resize", checkMobile);
	}, []);

	// Prevent hydration mismatch by not rendering until mounted
	if (!mounted) return null;

	// Render mobile or desktop badge based on screen size
	return isMobile ? <MobileComparisonBadge /> : <DesktopComparisonBadge />;
}
